/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Subscription_AccessInputs */



/**
* | output |
* | --- |
* | "You do not have access to the subscription management interface." |
*
* @param {No_Subscription_AccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_subscription_access = /** @type {((inputs?: No_Subscription_AccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Subscription_AccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous n'avez pas accès à l'interface de gestion des abonnements.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben keinen Zugriff auf die Benutzeroberfläche zur Abonnementverwaltung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non hai accesso all'interfaccia di gestione degli abbonamenti.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("У вас нет доступа к интерфейсу управления подписками.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No tienes acceso a la interfaz de gestión de suscripciones.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您没有订阅管理界面的访问权限。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプション管理インターフェースにアクセスできません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपको सदस्यता प्रबंधन इंटरफेस तक पहुंच प्राप्त नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você não tem acesso à interface de gerenciamento de assinaturas.")
	return /** @type {LocalizedString} */ ("You do not have access to the subscription management interface.")
});